<template>
  <nav class="nav">
    <div class="logo">
      <img class="img" src="@/assets/images/name.svg" />
    </div>
    <div class="navigation">
      <NavigationLinks :links="getNavLinks" />
      <div class="button">
        <BaseButton size="semi" color="primary" :to="{name: 'Start Production'}">
          <span class="nav-button font-semi" >Start production</span>
          <BaseIcon name="chevron-right" class="icon white" />
        </BaseButton>
      </div>
    </div>
    <NavigationUserInfo />
  </nav>
</template>

<script>
import BaseButton from "@/components/base/Button";
import BaseIcon from "@/components/base/Icon";
import NavigationLinks from "@/components/NavigationLinks";
import NavigationUserInfo from "@/components/NavigationUserInfo";

export default {
  name: "navigation",
  components: {
    BaseButton,
    BaseIcon,
    NavigationLinks,
    NavigationUserInfo
  },
  data() {
    return {
      persistentNavRoutes: [
        {
          name: "dashboard",
          title: "Home",
          icon: "home"
        }
      ],
      loggedInNavRoutes: [
        {
          name: "production",
          title: "Production",
          icon: "folder",
          children: [
            {
              name: "master",
              title: "Master"
            },
            {
              name: "in-progress",
              title: "In progress"
            },
            {
              name: "completed",
              title: "Completed"
            },
            {
              name: "approved",
              title: "Approved"
            }
          ]
        },
        {
          name: "traceability",
          title: "Traceability",
          icon: "compass",
          children: [
            {
              name: "lot-table",
              title: "Lot table"
            },
            {
              name: "order-table",
              title: "Order table"
            }
          ]
        },
        {
          name: "management",
          title: "Management",
          icon: "user-friends",
          children: [
            {
              name: "raw-materials",
              title: "Raw Materials"
            },
            {
              name: "devices",
              title: "Devices"
            },
            {
              name: "production-flows",
              title: "Production Flows"
            },
            {
              name: "production-steps",
              title: "Production Steps"
            },
            {
              name: "users",
              title: "Users"
            },
            {
              name: "backups",
              title: "Backups"
            }
          ]
        },
        // {
        //   name: "logout",
        //   title: "Log out",
        //   icon: "sign-out-alt"
        // }
      ],
      loggedOutNavRoutes: [
        {
          name: "login",
          title: "Log in",
          icon: "sign-in-alt"
        }
      ]
    };
  },
  computed: {
    getNavLinks() {
      let navLinks = [];
      // this.loggedIn
      true
        ? (navLinks = this.persistentNavRoutes.concat(this.loggedInNavRoutes))
        : (navLinks = this.persistentNavRoutes.concat(this.loggedOutNavRoutes));

      return navLinks;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/nav";

.font-semi {
  font-weight: 600;
}
</style>